function formatDate(date) {
  return date.getDay() + "-" + date.getMonth() + "-" + date.getFullYear();
}

export default formatDate;
